import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { makeStyles } from "@mui/styles";
import styled from "styled-components";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import CircularLoader from "../CircularLoader/CircularLoader";
import environmentVariables from "../../config/environmentVariables";
import { userInfoContext } from "../../context/userInfoContext";
const InputWrapper = styled.div`
  width: 100%;
  font-size: 18px;
  /* background: rgba(40, 43, 47, 0.8)r-; */
  outline: none;
  border: none;
  font-weight: 400;
  text-align: left;
  color: #75787b;
  line-height: 16px;
  // padding: 2px 0px 0px 20px;
  border-radius: 10px;
  border: none;
`;
const Paywith = styled.div`
  font-size: 16px;
  font-weight: 500;
  padding: 30px 0 10px;
  color: #d1d1d1;
`;
const Fortwoinputslandscape = styled.div`
  display: block;
  position: relative;
  @media (max-height: 480px) {
    display: flex;
    gap: 20px;
  }
`;
const Inputwidthlandscape = styled.div`

  @media (max-height: 480px) {
    width: 100%;
  }
`;
const PaywithBox = styled.div`
  font-size: 16px;
  position: relative;
`;

const ButtonWrapper = styled.div`
  padding: 5px 0 5px 0;
  margin-top: 10px;
`;
const Button = styled.button`
  background: rgb(31 92 106);
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.06);
  border: none;
  font-weight: 700;
  text-align: center;
  color: #fff;
  margin: 0 auto;
  display: block;
  border-radius: 10px;
  padding: 15px 50px;
  font-size: 18px;
  // cursor: pointer;
  cursor: pointer;
  width: 100%;
`;
const AddressWrapper = styled.div`
  margin: 1rem 0;
  position: relative;
  @media (max-height: 480px) {
    width: 100%;
  }

`;
const useStyles = makeStyles((theme) => ({
  customButton: {
    padding: "50px",
    backgroundColor: "#2a2a2a",
    border: "1px solid #484848",
    borderRadius: "10px",
    color: "#fff",
    minWidth: "360px",
    width: "580px",
    "@media (max-width: 768px)": {
      minWidth: "360px",
    },
    "@media (max-width: 600px)": {
      maxWidth: "220px",
      minWidth: "350px",
      padding: "40px 30px",
      backgroundColortransparent: true,
    },
    "@media (max-width: 400px)": {
      maxWidth: "220px",
      minWidth: "320px",
      padding: "40px 30px",
      backgroundColortransparent: true,
    },
  },
}));
const TextWrapper = styled.div``;
const Text = styled.div`
  font-size: 18px;
  font-family: "SweraDemo";
  padding: 14px 0;
  flex: 1;
  min-width: 0;
  font-family: inherit;
  font-weight: 700;
  text-align: left;
  color: #b9b9b9;
  line-height: 20px;
`;
const Styledselect = styled.select`
  background: transparent;
  border: 0;
  color: #75787b;
  cursor: pointer;
  :focus {
    border: 0;
    outline: 0;
  }
  :focus-visible {
    border: 0;
    outline: 0;
  }
`;
const NftNameConfirmHead = styled.div`
  font-size: 24px;
  font-weight: 600;
`;
const NftNameConfirm = styled.div`
  width: 100%;
  margin: 20px 0;
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  padding-top: 20px;
  border-bottom: 1px solid #484848;
  border-top: 1px solid #484848;
  justify-content: space-between;
`;
const NftAmountConfirmHeadPur = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
`;

const NftAmountConfirmHead2 = styled.div`
  font-size: 16px;
  color: #bbb;
`;
const NftAmountConfirmSubHead3 = styled.div`
  font-size: 16px;
  color: #fff;
`;
const PayButtons = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const ButtonConfirm = styled.button`
  background: linear-gradient(45deg, #0a5d6e, #00aacd);
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 24px;
  padding: 20px 80px;
  margin: 40px 0 10px;
  cursor: pointer;
  color: #e9e9e9;
  width: 100%;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
  }
  /* &:hover {
    background: linear-gradient(45deg, #fff, #d3d3d3);
    color: #151a1c;
  } */
`;

const Styledoption = styled.option`
  background: transparent;
  border: 0;
  color: #75787b;
  cursor: pointer;
`;

const ConversionPrice = styled.div`
  font-size: 14px;
  font-weight: 700;
  top: 395px;
  right: 36px;
  position: absolute;
  color: #b9b9b9;
  padding-top: 10px;
  text-align: right;
  @media (max-width:500px){
    top: 405px;
  }
`;
const ButtonCancel = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -15px;
  right: -20px;
  background-color: #b3b3b3;
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 20px;
  /* font-weight: 600; */
  padding: 20px;
  margin: 0;
  cursor: pointer;
  color: #000;
  width: 45px;
  height: 45px;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
    top: -25px;
    right: -15px;
  }
  @media (max-width: 600px) {
    top: -25px;
    right: -15px;
  }

  /* &:hover {
    background: linear-gradient(45deg, #fff, #d3d3d3);
    color: #151a1c;
  } */
`;
const BuyTokensWrapper = ({
  mldTokenName,
  maticTokenName,
  lordTokenName,
  usdtTokenName,
  allContractDetails,
}) => {
  const navigate = useNavigate();
  const classes = useStyles();
  const [tokenConversionRate, setTokenConversionRate] = useState(null);
  const [tokenAmount, setTokenAmount] = useState("");
  const [currencyAmount, setCurrencyAmount] = useState("");
  const [currency, setCurrency] = useState("USD");
  const [isSubmit, setIsSubmit] = useState(false);
  const [conversionRate, setConversionRate] = useState(0);
  
  const {userAccInfo, setUserAccInfo}=useContext(userInfoContext)

  const [confirmPopUP, setConfirmPopUP] = useState(false);
  const handleConversion = (e) => {
    const regex = /^\d{0,10}(\.\d{0,4})?$/;
    const value = e.target.value;

    // allow empty input or valid number format
    if (value === "" || regex.test(value)) {
      setCurrencyAmount(value);
      if (value !== "") {
        setTokenAmount((parseFloat(value) / conversionRate).toFixed(2));
      } else {
        setTokenAmount("");
      }
    }
    // setCurrencyAmount(e.target.value);
    // // if (conversionRate != 1) {
    // setTokenAmount(parseFloat(e.target.value / conversionRate).toFixed(2));
    // // }
  };
  const handleSubmit = () => {
    if (tokenAmount == 0 || tokenAmount == undefined || tokenAmount == null || tokenAmount == "" || isNaN(tokenAmount)) {
      toast.error("Amount is not valid", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    if (
      currencyAmount == 0 ||
      currencyAmount == undefined ||
      currencyAmount == null ||
      currencyAmount == "" || isNaN(currencyAmount)
    ) {
      toast.error("Amount is not valid", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    if (currency == "" || currency == null || currency == undefined || isNaN(currency)) {
      toast.error("Currency is not selected", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    setIsSubmit(true);
    // if (currency == "USD") {
    //   let data = {
    //     amount: parseFloat(tokenAmount).toFixed(2),
    //     currency: currency,
    //     user_address: allContractDetails?.address,
    //     token_amount: parseFloat(currencyAmount),
    //     token_name: getTokenName(),
    //   };
    //   let config = {
    //     method: "post",
    //     maxBodyLength: Infinity,
    //     url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get_trans_token`,
    //     headers: {
    //       "Content-Type": "application/json",
    //       authorization:`Bearer ${userAccInfo}`
    //     },
    //     data: data,
    //   };
    //   axios
    //     .request(config)
    //     .then((response) => {
    //       setIsSubmit(false);
    //       console.log(response?.data?.result?.API3G, "paymentgateway");
    //       if (response?.data?.result?.API3G?.Result?._text == "000") {
    //         window.open(
    //           `https://secure.3gdirectpay.com/payv3.php?ID=${response?.data?.result?.API3G?.TransToken?._text}`
    //         );
    //       } else {
    //         toast.error(response?.data?.result?.API3G?.Result?._text, {
    //           position: toast.POSITION.TOP_RIGHT,
    //         });
    //       }
    //     })
    //     .catch((error) => {
    //       setIsSubmit(false);
    //       console.log(error);
    //     });
    // } else 
      
      if (currency == "USD") {
      let data = {
        action: "PURCHASE",
        currencyCode: "AED",
        value: parseInt(tokenAmount * 100),
        user_address: allContractDetails?.address,
        token_amount: parseFloat(currencyAmount),
        token_name: getTokenName(),
      };

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/create_order_network_pay`,
        headers: {
          "Content-Type": "application/json",
          authorization:`Bearer ${userAccInfo}`
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          if (response?.data?.data) {
            if (response?.data?.data?._links?.payment?.href) {
              window.open(`${response?.data?.data?._links?.payment?.href}`);
            }
          }

          setIsSubmit(false);
        })
        .catch((error) => {
          setIsSubmit(false);
          console.log(error);
          toast.error(error?.response?.data?.message || error?.message || "Something went wrong");
        });
    } else {
      toast.error("currency is not valid");
    }
  };
  const getTokenName = () => {
    let token;
    if (mldTokenName) {
      token = "MLD";
    } else if (maticTokenName) {
      token = "MATIC";
    } else if (lordTokenName) {
      token = "LORD";
    } else if (usdtTokenName) {
      token = "USDT";
    }
    return token;
  };
  const getConversionRates = () => {
    let token = getTokenName();

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/fetch_conversion_rate_by_currency?token=${token}`,
      headers:{authorization:`Bearer ${userAccInfo}`}
    };

    axios
      .request(config)
      .then((response) => {
        setTokenConversionRate(response.data?.data);
        console.log(response.data?.data?.conversion_rate[0]);
        setConversionRate(
          response.data?.data?.conversion_rate[0]?.conversion_rate
        );
        const rate = response.data?.data?.conversion_rate[0]?.conversion_rate;
        setCurrencyAmount(tokenAmount ? rate * tokenAmount : "");
        // setCurrencyAmount(
        //   response.data?.data?.conversion_rate[0]?.conversion_rate * tokenAmount
        // );
        setCurrency(response.data?.data?.conversion_rate[0]?.currency);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getConversionRates();
  }, []);
  return (
    <>

    <Fortwoinputslandscape>
      <Inputwidthlandscape>
        <AddressWrapper>
          <TextWrapper>
          <Text>You Receive</Text>
        </TextWrapper>
        <InputWrapper style={{ position: "relative" }}>
          <input
            style={{
              width: "100%",
              fontSize: "24px",
              background: "rgba(40,43,47,.8)",
              outline: "none",
              border: "none",
              fontWeight: "400",
              textAlign: "left",
              color: "#75787b",
              lineHeight: "16px",
              padding: "15px 15px",
              borderRadius: "10px",
              border: "none",
            }}
            value={currencyAmount}
            onKeyDown={(e)=>{
              if (e.key == "-") { 
                e.preventDefault();
              }else if(e.key=="+"){
                e.preventDefault();
              }
            }}
            onChange={handleConversion}
            placeholder="You Receive"
          />
          <div
            style={{
              position: "absolute",
              top: "22px",
              right: "15px",
              color: "#fff",
            }}
          >
            {mldTokenName && "$MLD"}
            {maticTokenName && "MATIC"}
            {lordTokenName && "$LORD"}
            {usdtTokenName && "USDT (POL)"}
          </div>
        </InputWrapper>
        </AddressWrapper>
      </Inputwidthlandscape>

      <Inputwidthlandscape>
        <AddressWrapper>
          <TextWrapper>
          <Text>You Spend</Text>
        </TextWrapper>
        <InputWrapper>
          <div style={{ position: "relative" }}>
            <input
              style={{
                width: "100%",
                fontSize: "24px",
                background: "rgba(40,43,47,.8)",
                outline: "none",
                border: "none",
                fontWeight: "400",
                textAlign: "left",
                color: "#75787b",
                lineHeight: "16px",
                padding: "15px 15px",
                borderRadius: "10px",
                border: "none",
                marginBottom: "20px",
              }}
              // value={tokenAmount ? parseFloat(tokenAmount).toFixed(2) : "0"}
              value={tokenAmount !== "" && !isNaN(tokenAmount) ? parseFloat(tokenAmount).toFixed(2) : ""}
              disabled={true}
              placeholder="You Spend"
            />
            <div style={{ position: "absolute", top: "22px", right: "15px" }}>
              {/* <Styledselect
                value={conversionRate}
                onChange={(e) => {
                  setConversionRate(e.target.value);
                  setCurrency(e.target.selectedOptions[0].textContent);
                  if (tokenAmount && currencyAmount) {
                    setTokenAmount(currencyAmount / e.target.value);
                  }
                }}
              >
                {tokenConversionRate &&
                  tokenConversionRate.conversion_rate &&
                  tokenConversionRate.conversion_rate.length > 0 &&
                  tokenConversionRate.conversion_rate.map((val) => {
                    if (val?.currency) {
                      return (
                        <Styledoption value={val?.conversion_rate}>
                          {val?.currency}
                        </Styledoption>
                      );
                    }
                  })}
              </Styledselect> */}
              <div style={{fontWeight:"500",fontSize:"14px"}}>FIAT</div>
            </div>
          </div>

          {/* <Paywith>Pay With</Paywith>
              <PaywithBox
                style={{
                  width: "100%",
                  fontSize: "18px",
                  background: "rgba(40,43,47,.8)",
                  outline: "none",
                  border: "none",
                  fontWeight: "400",
                  textAlign: "left",
                  color: "#75787b",
                  lineHeight: "16px",
                  padding: "15px 15px",
                  borderRadius: "10px",
                  border: "none",
                }}
                placeholder="You Receive"
              >Visa/Credit Card</PaywithBox> */}
        </InputWrapper>
        </AddressWrapper>
      </Inputwidthlandscape>
    </Fortwoinputslandscape>

    
        <ConversionPrice>{`1 ${getTokenName()=="MLD"||getTokenName()=="LORD"?"$":""}${getTokenName()=="USDT"?"USDT (POL)":getTokenName()} = ${conversionRate && currency?parseFloat(
          1 / conversionRate
        ).toFixed(4):0} ${currency}`}</ConversionPrice>
     

      <ButtonWrapper>
        <Button
          style={
            allContractDetails && tokenAmount >= 0
              ? { cursor: "pointer" }
              : {
                  cursor: "default",
                  opacity: "0.5",
                }
          }
          disabled={tokenAmount == 0 || currencyAmount == 0 || currency == "" || tokenAmount == "" || currencyAmount == "" || isNaN(tokenAmount) || isNaN(currencyAmount) ? true : false}
        >
          <div
            style={{
              marginTop: "0px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() => {
              if (allContractDetails && tokenAmount >= 0) {
                setConfirmPopUP(true);
              }
            }}
          >
            {isSubmit == true ? <CircularLoader /> : "Buy"}
          </div>
        </Button>
      </ButtonWrapper>
      <Dialog
        open={confirmPopUP}
        onClose={() => setConfirmPopUP(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: { overflow: "initial", backgroundColor: "transparent" },
        }}
      >
        <ButtonCancel onClick={() => setConfirmPopUP(false)} color="primary">
          X
        </ButtonCancel>
        <div className={classes.customButton}>
          <DialogTitle
            id="alert-dialog-title"
            style={{
              textAlign: "left",
              fontSize: "28px",
              fontWeight: "500",
              padding: "0",
            }}
          >
            Confirm Buy Token
          </DialogTitle>
          <DialogContent style={{ padding: "0 0 40px" }}>
            <DialogContentText
              id="alert-dialog-description"
              style={{
                textAlign: "left",
                color: "#bbb",
                fontSize: "16px",
              }}
            >
              Please verify this information to complete the transaction
            </DialogContentText>
          </DialogContent>

          <NftNameConfirm>
            <NftNameConfirmHead>{`${getTokenName()=="MLD"||getTokenName()=="LORD"?"$":""}${getTokenName()=="USDT"?"USDT (POL)":getTokenName()} Purchasing`}</NftNameConfirmHead>
            <NftNameConfirmHead>{currencyAmount}</NftNameConfirmHead>
          </NftNameConfirm>

          <NftAmountConfirmHeadPur>
            <NftAmountConfirmHead2>Amount Spending</NftAmountConfirmHead2>
            <NftAmountConfirmSubHead3>{`${currency} ${
              tokenAmount ? parseFloat(tokenAmount).toFixed(2) : "0"
            }`}</NftAmountConfirmSubHead3>
          </NftAmountConfirmHeadPur>
          <DialogActions>
            <PayButtons>
              <ButtonConfirm
                onClick={(e) => {
                  setConfirmPopUP(false);
                  handleSubmit();
                  e.preventDefault();
                }}
                color="primary"
                autoFocus
              >
                Confirm
              </ButtonConfirm>
            </PayButtons>
          </DialogActions>
        </div>
      </Dialog>
    </>
  );
};

export default BuyTokensWrapper;
